import {Component, Input} from '@angular/core';
import {TooltipPosition} from '@angular/material/tooltip';

@Component({
  selector: 'app-custom-tooltip',
  templateUrl: './custom-tooltip.component.html',
  styleUrls: []
})
export class CustomTooltipComponent {
  @Input() matTooltip = '';
  @Input() matTooltipPosition: TooltipPosition = 'below';
  @Input() matTooltipShowDelay = 0;
  @Input() matTooltipHideDelay = 0;
  @Input() matTooltipClass: any = '';
  @Input() matTooltipDisabled = false;
  @Input() matIconName = 'help_outline';

  constructor() {
  }
}
